import cjsModule from './index.js';

export const DEFAULT_OPTIONS = cjsModule.DEFAULT_OPTIONS;
export const format = cjsModule.format;
export const plugins = cjsModule.plugins;
export default cjsModule.default;
